import { useTheme } from "@react-navigation/native";
import { useMediaQuery } from "native-base";
import React from "react";
import { SafeAreaView, ScrollView, StyleSheet, View } from "react-native";

function AppScreen({ children, style }) {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	const { colors } = useTheme();
	const styles = makeStyles(colors);
	return (
		<ScrollView
			style={[
				styles.wrapper,
				{ paddingHorizontal: isDesktopOrLaptop[0] ? 200 : 10 },
			]}
		>
			<SafeAreaView style={[styles.screen, style]}>
				<View style={[styles.view, style]}>{children}</View>
			</SafeAreaView>
		</ScrollView>
	);
}

const makeStyles = (colors) =>
	StyleSheet.create({
		wrapper: {
			flex: 1,
			backgroundColor: colors.background,
		},
		screen: {
			flex: 1,
			// backgroundColor: "#EEFC",
		},
		view: {
			flex: 1,
		},
	});

export default AppScreen;
